import { call, put, takeLatest, delay, select } from 'redux-saga/effects';

import {
	getBases,
	getBasesSuccess,
	getBasesFailure,
	getBaseById,
	getBaseByIdSuccess,
	getBaseByIdFailure,
	createBase,
	createBaseFailure,
	createBaseSuccess,
	updateBase,
	updateBaseFailure,
	updateBaseSuccess,
	removeBase,
	removeBaseFailure,
	removeBaseSuccess,
	getOrdersVaiFacil,
	getOrdersVaiFacilSuccess,
	getOrdersVaiFacilFailure,
	dispatchOrdersVaiFacil,
	dispatchOrdersVaiFacilSuccess,
	dispatchOrdersVaiFacilFailure,
} from '.';

import baseService from '../../../services/BaseService';

function* rootSaga() {
	yield takeLatest(getBases, getBasesSaga);
	yield takeLatest(getBaseById, getBaseByIdSaga);
	yield takeLatest(createBase, createBaseSaga);
	yield takeLatest(updateBase, updateBaseSaga);
	yield takeLatest(removeBase, removeBaseSaga);
	yield takeLatest(getOrdersVaiFacil, getOrdersVaiFacilSaga);
	yield takeLatest(dispatchOrdersVaiFacil, dispatchOrdersVaiFacilSaga);
}

function* getBasesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(baseService.getAll, payload);
		yield put(getBasesSuccess(response));
	} catch (error) {
		yield put(getBasesFailure(error));
	}
}

function* getBaseByIdSaga({ payload }) {
	try {
		yield delay(300);
		const base = yield call(baseService.get, payload);
		yield put(getBaseByIdSuccess(base));
	} catch (error) {
		yield put(getBaseByIdFailure(error));
	}
}

function* getOrdersVaiFacilSaga({ payload }) {
	const { baseId } = payload;
	try {
		yield delay(300);
		const response = yield call(baseService.getOrdersVaiFacil, baseId);
		yield put(getOrdersVaiFacilSuccess(response));
	} catch (error) {
		yield put(getOrdersVaiFacilFailure(error));
	}
}

function* dispatchOrdersVaiFacilSaga({ payload }) {
	const { baseId, delivermanId, trackingCodes } = payload;
	try {
		yield delay(300);
		const response = yield call(
			baseService.dispatchOrdersVaiFacil,
			baseId,
			delivermanId,
			trackingCodes,
		);
		yield put(dispatchOrdersVaiFacilSuccess(response));

		// Refreshing the orders list since we dispatched some:
		yield put(getOrdersVaiFacil({ baseId }));
	} catch (error) {
		yield put(dispatchOrdersVaiFacilFailure(error));
	}
}

function* createBaseSaga({ payload }) {
	try {
		yield delay(300);
		const createdBase = yield call(baseService.create, payload);
		yield put(createBaseSuccess(createdBase));
		const tableParams = yield select(({ bases }) => bases.bases.tableParams);
		yield put(getBases(tableParams));
	} catch (error) {
		yield put(createBaseFailure(error));
	}
}

function* updateBaseSaga({ payload }) {
	const { baseId: id, data: baseForm } = payload;
	try {
		yield delay(300);
		const updatedBase = yield call(baseService.update, id, baseForm);
		yield put(updateBaseSuccess(updatedBase));

		// Refreshing the bases list since we updated one:
		const tableParams = yield select(({ bases }) => bases.bases.tableParams);
		yield put(getBases(tableParams));
	} catch (error) {
		yield put(updateBaseFailure(error));
	}
}

function* removeBaseSaga({ payload }) {
	const id = payload;
	try {
		yield delay(300);
		const response = yield call(baseService.remove, id);
		yield put(removeBaseSuccess(response));

		// Refreshing the bases list since we removed one:
		const tableParams = yield select(({ bases }) => bases.bases.tableParams);
		yield put(getBases(tableParams));
	} catch (error) {
		yield put(removeBaseFailure(error));
	}
}

export default rootSaga;
